import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import SweetAlert from 'react-bootstrap-sweetalert';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faExclamation, faHeart, faLink, faTrash,
} from '@fortawesome/free-solid-svg-icons';
import Input from '../../components/Input';
import TextArea from '../../components/TextArea';
import Loading from '../../components/Loading';
import api from '../../services/api';
import { Container, Table, ButtonPanel } from './styles';

import Button from '../../components/Button';

export default class EventPromoters extends Component {
  state = {
    activePromoters: [],
    activePromotersCount: null,
    advertences: [],
    affiliateLink: '',
    alert: {},
    favoritePromoters: [],
    invitedPromoters: [],
    loading: true,
    promoterName: '',
    promoterEmail: '',
    showAlert: false,
    slots: null,
  };

  genreTranslation = {
    male: 'Masculino',
    female: 'Feminino',
  };

  static propTypes = {
    match: PropTypes.shape().isRequired,
  };

  componentDidMount() {
    this.loadEvent();
    this.loadEventPromoters();
    this.loadInvitedPromoters();
  }

  loadEvent = async () => {
    try {
      const { data } = await api.get(`events/${this.props.match.params.id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token_producer')}`,
        },
      });

      this.setState({
        activePromotersCount: data.event.active_promoters,
        slots: data.event.slots,
      });

      this.setState({ loading: false });
    } catch (err) {
      this.setState({ activePromotersCount: null, slots: null });
    }
  };

  loadEventPromoters = async () => {
    try {
      const { data } = await api.get('event_promoters', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token_producer')}`,
        },
        params: {
          event_id: this.props.match.params.id,
        },
      });

      data.promoters = data.promoters.map(promoter => ({
        ...promoter,
        genre: this.genreTranslation[promoter.genre],
      }));
      this.setState({ activePromoters: data.promoters });
    } catch (err) {
      this.setState({ activePromoters: [] });
    }
  };

  loadFavoritePromoters = async () => {
    try {
      const { data } = await api.get('favorite_promoters', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token_producer')}`,
        },
      });
      this.setState({ favoritePromoters: data.promoters });
    } catch (err) {
      this.setState({ favoritePromoters: [] });
    }
  };

  loadInvitedPromoters = async () => {
    try {
      const { data } = await api.get('event_promoters', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token_producer')}`,
        },
        params: {
          event_id: this.props.match.params.id,
          status: 'invited',
        },
      });
      this.setState({ invitedPromoters: data.promoters });
    } catch (err) {
      this.setState({ invitedPromoters: [] });
    }
  };

  viewAdvertences = (promoter_id) => {
    this.loadAdvertences(promoter_id);
    this.setState({
      currentPromoterId: promoter_id,
    });
  };

  loadAdvertences = async (promoter_id) => {
    try {
      const { data } = await api.get('advertences', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token_producer')}`,
        },
        params: {
          event_id: this.props.match.params.id,
          promoter_id,
        },
      });

      const formated = data.advertences.map(advertence => ({
        ...advertence,
        warned_at: moment(advertence.warned_at).format('DD/MM/YYYY, HH:mm[h]'),
      }));

      this.setState({
        advertences: formated,
      });
    } catch (err) {
      this.setState(
        {
          alert: {
            title: 'Erro',
            type: 'danger',
            messages: ['Não foi possível carregar as advertências. Por favor, atualize a página.'],
            onConfirm: () => this.closeAlert(),
          },
        },
        () => {
          this.openAlert();
        },
      );
    }
  };

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleInviteModal = () => {
    this.loadFavoritePromoters();
  };

  handleInviteByEmail = async (e) => {
    e.preventDefault();

    const { invitedPromoters, promoterEmail, promoterName } = this.state;

    if (promoterName === '') {
      this.setState(
        {
          alert: {
            title: 'Erro',
            type: 'danger',
            messages: ['Preencha o nome do divulgador.'],
            onConfirm: () => this.closeAlert(),
          },
        },
        () => this.setState({ showAlert: true }),
      );
    } else if (promoterEmail === '') {
      this.setState(
        {
          alert: {
            title: 'Erro',
            type: 'danger',
            messages: ['Preencha o e-mail do divulgador.'],
            onConfirm: () => this.closeAlert(),
            showAlert: true,
          },
        },
        () => this.setState({ showAlert: true }),
      );
    } else {
      try {
        const formData = new FormData();
        formData.append('name', promoterName);
        formData.append('email', promoterEmail);
        formData.append('event_id', this.props.match.params.id);
        const { data } = await api.post('event_promoters', formData, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token_producer')}`,
          },
        });

        if (!invitedPromoters.find(p => p.id === data.id)) {
          this.setState(prevState => ({
            invitedPromoters: [...prevState.invitedPromoters, data],
          }));
        }
        this.setState(
          {
            alert: {
              title: 'Divulgador convidado!',
              type: 'success',
              messages: ['O divulgador foi convidado com sucesso.'],
              onConfirm: () => this.closeAlert(),
            },
          },
          () => {
            this.openAlert();
            this.setState({
              promoterName: '',
              promoterEmail: '',
            });
          },
        );
      } catch (err) {
        this.setState(
          {
            alert: {
              title: 'Erro',
              type: 'danger',
              messages: ['Não foi possível convidar o divulgador. Por favor, atualize a página.'],
              onConfirm: () => this.closeAlert(),
            },
          },
          () => {
            this.openAlert();
          },
        );
      }
    }
  };

  handleAffiliateModal = (id) => {
    this.setState({
      currentPromoterId: id,
    });
  };

  handleAffiliateLinkSubmit = async (e) => {
    e.preventDefault();

    try {
      const { affiliateLink, activePromoters, currentPromoterId } = this.state;
      const formData = new FormData();
      formData.append('promoter_id', currentPromoterId);
      formData.append('affiliate_link', affiliateLink);
      await api.patch(`event_promoters/${this.props.match.params.id}`, formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token_producer')}`,
        },
      });

      const promoterIndex = activePromoters.findIndex(
        promoter => promoter.id === currentPromoterId,
      );
      const updatedPromoters = activePromoters;
      updatedPromoters[promoterIndex].affiliate_link = affiliateLink;

      this.setState({
        activePromoters: updatedPromoters,
        affiliateLink: '',
      });

      document.getElementById('closeAffiliateModal').click();
    } catch (err) {
      this.setState(
        {
          alert: {
            title: 'Erro',
            type: 'danger',
            messages: [
              'Não foi possível atualizar o link de afiliado. Por favor, atualize a página.',
            ],
            onConfirm: () => this.closeAlert(),
          },
        },
        () => {
          this.openAlert();
        },
      );
    }
  };

  openAlert = () => {
    this.setState({
      showAlert: true,
    });
  };

  closeAlert = () => {
    this.setState({
      showAlert: false,
    });
  };

  invitePromoter = async (id) => {
    try {
      const formData = new FormData();
      formData.append('promoter_id', id);
      formData.append('event_id', this.props.match.params.id);
      const { data } = await api.post('event_promoters', formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token_producer')}`,
        },
      });

      this.setState(prevState => ({
        invitedPromoters: [...prevState.invitedPromoters, data],
      }));
    } catch (err) {
      this.setState(
        {
          alert: {
            title: 'Erro',
            type: 'danger',
            messages: ['Não foi possível convidar o divulgador. Por favor, atualize a página.'],
            onConfirm: () => this.closeAlert(),
          },
        },
        () => {
          this.openAlert();
        },
      );
    }
  };

  addFavorite = async (id) => {
    const { activePromoters } = this.state;
    try {
      const formData = new FormData();
      formData.append('promoter_id', id);
      await api.post('favorite_promoters', formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token_producer')}`,
        },
      });

      const promoterIndex = activePromoters.findIndex(promoter => promoter.id === id);
      const updatedPromoters = activePromoters;
      updatedPromoters[promoterIndex].is_favorite = true;

      this.setState({
        activePromoters: updatedPromoters,
      });
    } catch (err) {
      this.setState(
        {
          alert: {
            title: 'Erro',
            type: 'danger',
            messages: ['Não foi possível favoritar o divulgador. Por favor, atualize a página.'],
            onConfirm: () => this.closeAlert(),
          },
        },
        () => {
          this.openAlert();
        },
      );
    }
  };

  deleteFavorite = async (id) => {
    const { activePromoters } = this.state;
    try {
      await api.delete(`favorite_promoters/${id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token_producer')}`,
        },
      });

      const promoterIndex = activePromoters.findIndex(promoter => promoter.id === id);
      const updatedPromoters = activePromoters;
      updatedPromoters[promoterIndex].is_favorite = false;

      this.setState({
        activePromoters: updatedPromoters,
      });
    } catch (err) {
      this.setState(
        {
          alert: {
            title: 'Erro',
            type: 'danger',
            messages: ['Não foi possível desfavoritar o divulgador. Por favor, atualize a página.'],
            onConfirm: () => this.closeAlert(),
          },
        },
        () => {
          this.openAlert();
        },
      );
    }
  };

  addAdvertence = async (e) => {
    e.preventDefault();

    try {
      const { advertenceReason, currentPromoterId } = this.state;
      const formData = new FormData();
      formData.append('reason', advertenceReason);
      formData.append('promoter_id', currentPromoterId);
      formData.append('event_id', this.props.match.params.id);
      await api.post('advertences', formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token_producer')}`,
        },
      });

      this.setState(
        {
          alert: {
            title: 'Advertência adicionada!',
            type: 'success',
            messages: ['A advertência foi adicionada com sucesso.'],
            onConfirm: () => this.closeAlert(),
          },
        },
        () => {
          this.openAlert();
          this.setState({
            advertenceReason: '',
          });
        },
      );

      document.getElementById('closeAdvertenceModal').click();
    } catch (err) {
      this.setState(
        {
          alert: {
            title: 'Erro',
            type: 'danger',
            messages: ['Não foi possível adicionar a advertência. Por favor, atualize a página.'],
            onConfirm: () => this.closeAlert(),
          },
        },
        () => {
          this.openAlert();
        },
      );
    }
  };

  deleteAdvertence = (id) => {
    this.setState(
      {
        alert: {
          title: 'Atenção',
          type: 'warning',
          messages: ['Tem certeza que deletar esta advertência?'],
          confirmBtnText: 'Deletar',
          confirmBtnBsStyle: 'danger',
          showCancel: true,
          cancelBtnText: 'Não',
          cancelBtnBsStyle: 'info',
          onConfirm: () => this.confirmDeleteAdvertence(id),
        },
      },
      () => {
        this.openAlert();
      },
    );
  };

  confirmDeleteAdvertence = async (id) => {
    const { advertences } = this.state;
    try {
      await api.delete(`advertences/${id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token_producer')}`,
        },
      });

      this.setState({ advertences: advertences.filter(advertence => advertence.id !== id) });
      this.closeAlert();
    } catch (err) {
      this.setState(
        {
          alert: {
            title: 'Erro',
            type: 'danger',
            messages: ['Não foi possível deletar a advertência. Por favor, atualize a página.'],
            onConfirm: () => this.closeAlert(),
          },
        },
        () => {
          this.openAlert();
        },
      );
    }
  };

  kickPromoter = (id) => {
    this.setState(
      {
        alert: {
          title: 'Atenção',
          type: 'warning',
          messages: ['Tem certeza que expulsar o divulgador do evento?'],
          confirmBtnText: 'Expulsar',
          confirmBtnBsStyle: 'danger',
          showCancel: true,
          cancelBtnText: 'Não',
          cancelBtnBsStyle: 'info',
          onConfirm: () => this.confirmKickPromoter(id),
        },
      },
      () => {
        this.openAlert();
      },
    );
  };

  confirmKickPromoter = async (id) => {
    const { activePromoters } = this.state;
    try {
      await api.delete(`event_promoters/${this.props.match.params.id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token_producer')}`,
        },
        params: {
          promoter_id: id,
        },
      });

      this.setState({ activePromoters: activePromoters.filter(promoter => promoter.id !== id) });
      this.loadEvent();
      this.closeAlert();
    } catch (err) {
      this.setState(
        {
          alert: {
            title: 'Erro',
            type: 'danger',
            messages: ['Não foi possível expulsar o divulgador. Por favor, atualize a página.'],
            onConfirm: () => this.closeAlert(),
          },
        },
        () => {
          this.openAlert();
        },
      );
    }
  };

  render() {
    const {
      activePromoters,
      activePromotersCount,
      advertences,
      advertenceReason,
      affiliateLink,
      alert: {
        cancelBtnText,
        cancelBtnBsStyle,
        confirmBtnText,
        confirmBtnBsStyle,
        messages,
        onConfirm,
        showCancel,
        title,
        type,
      },
      favoritePromoters,
      invitedPromoters,
      loading,
      promoterName,
      promoterEmail,
      showAlert,
      slots,
    } = this.state;

    return (
      <Fragment>
        {loading ? (
          <Loading />
        ) : (
          <Container>
            <h1 className="page-title">
              Promoters ativos ({activePromotersCount}/{slots})
            </h1>
            <div className="box">
              <div className="row">
                <div className="col-12">
                  <ButtonPanel>
                    <button
                      type="button"
                      onClick={this.handleInviteModal}
                      className="btn btn-success"
                      data-toggle="modal"
                      data-target="#invitePromoter"
                    >
                      Convidar divulgador
                    </button>
                  </ButtonPanel>
                  {activePromoters.length > 0 ? (
                    <div className="table-wrapper">
                      <Table className="table">
                        <thead>
                          <tr>
                            <th>Foto</th>
                            <th>Nome</th>
                            <th>Instagram</th>
                            <th>Gênero</th>
                            <th>Link de afiliado</th>
                            <th>Opções</th>
                            <th>Advertências</th>
                          </tr>
                        </thead>
                        <tbody>
                          {activePromoters.map(promoter => (
                            <tr key={promoter.id}>
                              <td>
                                <div
                                  className="profile-image"
                                  style={
                                    promoter.avatar.url && {
                                      backgroundImage: `url(${promoter.avatar.url})`,
                                    }
                                  }
                                />
                              </td>
                              <td>{promoter.name}</td>
                              <td>
                                <a
                                  href={`http://instagram.com/${promoter.instagram_username}`}
                                  target="blank"
                                >
                                  @{promoter.instagram_username}
                                </a>
                              </td>
                              <td>{promoter.genre}</td>
                              <td>
                                {promoter.affiliate_link ? (
                                  <a href={`http://${promoter.affiliate_link}`} target="blank">
                                    {promoter.affiliate_link}
                                  </a>
                                ) : (
                                  '-'
                                )}
                              </td>
                              <td>
                                {promoter.is_favorite ? (
                                  <Button
                                    onClick={() => this.deleteFavorite(promoter.id)}
                                    className="btn-success btn-small"
                                  >
                                    <FontAwesomeIcon icon={faHeart} />
                                  </Button>
                                ) : (
                                  <Button
                                    onClick={() => this.addFavorite(promoter.id)}
                                    className="btn-light btn-small"
                                  >
                                    <FontAwesomeIcon icon={faHeart} />
                                  </Button>
                                )}
                                {promoter.affiliate_link ? (
                                  <button
                                    onClick={() => this.handleAffiliateModal(promoter.id)}
                                    type="button"
                                    className="btn btn-success btn-small"
                                    data-toggle="modal"
                                    data-target="#addAffiliateLink"
                                  >
                                    <FontAwesomeIcon icon={faLink} />
                                  </button>
                                ) : (
                                  <button
                                    onClick={() => this.handleAffiliateModal(promoter.id)}
                                    type="button"
                                    className="btn btn-light btn-small"
                                    data-toggle="modal"
                                    data-target="#addAffiliateLink"
                                  >
                                    <FontAwesomeIcon icon={faLink} />
                                  </button>
                                )}
                                <Button
                                  onClick={() => this.kickPromoter(promoter.id)}
                                  className="btn-dark btn-small"
                                >
                                  <FontAwesomeIcon icon={faTrash} />
                                </Button>
                              </td>
                              <td>
                                <button
                                  onClick={() => this.viewAdvertences(promoter.id)}
                                  type="button"
                                  className="btn btn-danger btn-small"
                                  data-toggle="modal"
                                  data-target="#viewAdvertences"
                                >
                                  <FontAwesomeIcon icon={faExclamation} />
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </div>
                  ) : (
                    <h5 className="text-center">Este evento não possui divulgadores ativos.</h5>
                  )}
                </div>
              </div>
            </div>

            <h2 className="page-title">Divulgadores convidados</h2>
            <div className="box">
              <div className="row">
                <div className="col-12">
                  {invitedPromoters.length > 0 ? (
                    <div className="table-wrapper">
                      <Table className="table">
                        <thead>
                          <tr>
                            <th>Foto</th>
                            <th>Nome</th>
                            <th>Instagram</th>
                          </tr>
                        </thead>
                        <tbody>
                          {invitedPromoters.map(promoter => (
                            <tr key={promoter.id}>
                              <td>
                                <div
                                  className="profile-image"
                                  style={
                                    promoter.avatar.url && {
                                      backgroundImage: `url(${promoter.avatar.url})`,
                                    }
                                  }
                                />
                              </td>
                              <td>{promoter.name}</td>
                              <td>
                                {promoter.instagram_username ? (
                                  <a
                                    href={`http://instagram.com/${promoter.instagram_username}`}
                                    target="blank"
                                  >
                                    @{promoter.instagram_username}
                                  </a>
                                ) : (
                                  '-'
                                )}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </div>
                  ) : (
                    <h5 className="text-center">Nenhum divulgador foi convidado.</h5>
                  )}
                </div>
              </div>
            </div>

            {showAlert && (
              <SweetAlert
                type={type}
                confirmBtnText={confirmBtnText}
                confirmBtnBsStyle={confirmBtnBsStyle}
                showCancel={showCancel}
                cancelBtnText={cancelBtnText}
                cancelBtnBsStyle={cancelBtnBsStyle}
                title={title}
                onConfirm={onConfirm}
                onCancel={this.closeAlert}
              >
                <ul>
                  {messages.map(msg => (
                    <li key={msg}>{msg}</li>
                  ))}
                </ul>
              </SweetAlert>
            )}

            <div
              className="modal fade"
              id="invitePromoter"
              tabIndex="-1"
              role="dialog"
              aria-labelledby="invitePromoterLabel"
              aria-hidden="true"
            >
              <div className="modal-dialog" role="document" style={{ maxWidth: '800px' }}>
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title" id="invitePromoterLabel">
                      Convidar divulgador
                    </h5>
                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div className="modal-body">
                    <h5>Por email:</h5>
                    <form onSubmit={this.handleInviteByEmail}>
                      <div className="input-group">
                        <Input
                          type="text"
                          onChange={this.handleChange}
                          value={promoterName}
                          name="promoterName"
                          className="form-control"
                          placeholder="Nome do divulgador"
                        />
                        <Input
                          type="email"
                          onChange={this.handleChange}
                          value={promoterEmail}
                          name="promoterEmail"
                          className="form-control"
                          placeholder="Email do divulgador"
                        />
                        <div className="input-group-append">
                          <button className="btn btn-primary" type="submit">
                            Convidar
                          </button>
                        </div>
                      </div>
                    </form>
                    <hr />
                    <h5>Favoritos:</h5>
                    {favoritePromoters.length > 0 ? (
                      <div className="table-wrapper">
                        <Table className="table">
                          <thead>
                            <tr>
                              <th>Foto</th>
                              <th>Nome</th>
                              <th>Cidade</th>
                              <th>Instagram</th>
                              <th>Nº de seguidores</th>
                              <th>Engajamento</th>
                              <th>Nota média</th>
                              <th>Convite</th>
                            </tr>
                          </thead>
                          <tbody>
                            {favoritePromoters.map(promoter => (
                              <tr key={promoter.id}>
                                <td>
                                  <div
                                    className="profile-image"
                                    style={
                                      promoter.avatar.url && {
                                        backgroundImage: `url(${promoter.avatar.url})`,
                                      }
                                    }
                                  />
                                </td>
                                <td>{promoter.name}</td>
                                <td>{promoter.city}</td>
                                <td>
                                  <a
                                    href={`http://instagram.com/${promoter.instagram_username}`}
                                    target="blank"
                                  >
                                    @{promoter.instagram_username}
                                  </a>
                                </td>
                                <td>{promoter.followers ? promoter.followers : '-'}</td>
                                <td>{promoter.engagement ? promoter.engagement : '-'}</td>
                                <td>{promoter.rating ? promoter.rating : '-'}</td>
                                <td>
                                  {invitedPromoters.find(p => p.id === promoter.id)
                                  || activePromoters.find(p => p.id === promoter.id) ? (
                                    <Button className="btn-success btn-small">Convidado</Button>
                                    ) : (
                                      <Button
                                        onClick={() => this.invitePromoter(promoter.id)}
                                        className="btn-outline-success btn-small"
                                      >
                                      Convidar
                                      </Button>
                                    )}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      </div>
                    ) : (
                      <p className="text-center">Você não possui divulgadores favoritos.</p>
                    )}
                  </div>
                </div>
              </div>
            </div>

            <div
              className="modal fade"
              id="addAffiliateLink"
              tabIndex="-1"
              role="dialog"
              aria-labelledby="addAffiliateLinkLabel"
              aria-hidden="true"
            >
              <div className="modal-dialog" role="document">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title" id="addAffiliateLinkLabel">
                      Adicionar link de afiliado
                    </h5>
                    <button
                      id="closeAffiliateModal"
                      type="button"
                      className="close"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div className="modal-body">
                    <form onSubmit={this.handleAffiliateLinkSubmit}>
                      <div className="input-group">
                        <div className="input-group-prepend">
                          <span className="input-group-text">http://</span>
                        </div>
                        <Input
                          type="text"
                          onChange={this.handleChange}
                          value={affiliateLink}
                          name="affiliateLink"
                          className="form-control"
                          placeholder="Link de afiliado"
                        />
                        <div className="input-group-append">
                          <button className="btn btn-primary" type="submit">
                            Atualizar
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>

            <div
              className="modal fade"
              id="viewAdvertences"
              tabIndex="-1"
              role="dialog"
              aria-labelledby="viewAdvertencesLabel"
              aria-hidden="true"
            >
              <div className="modal-dialog" role="document" style={{ maxWidth: '800px' }}>
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title" id="viewAdvertencesLabel">
                      Advertências
                    </h5>
                    <button
                      id="closeAdvertenceModal"
                      type="button"
                      className="close"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div className="modal-body">
                    <h5>Adicionar advertência:</h5>
                    <form onSubmit={this.addAdvertence}>
                      <div className="input-group">
                        <TextArea
                          onChange={this.handleChange}
                          value={advertenceReason}
                          name="advertenceReason"
                          className="form-control"
                          placeholder="Motivo"
                        />
                        <button className="btn btn-primary send-advertence" type="submit">
                          Enviar
                        </button>
                      </div>
                    </form>
                    <hr />
                    <h5>Advertências existentes:</h5>
                    {advertences.length > 0 ? (
                      <div className="table-wrapper">
                        <Table className="table">
                          <thead>
                            <tr>
                              <th>Data</th>
                              <th>Advertido por</th>
                              <th>Motivo</th>
                              <th>Excluir advertência</th>
                            </tr>
                          </thead>
                          <tbody>
                            {advertences.map(advertence => (
                              <tr key={advertence.id}>
                                <td>{advertence.warned_at}</td>
                                <td>{advertence.producer_name}</td>
                                <td>{advertence.reason}</td>
                                <td>
                                  <Button
                                    onClick={() => this.deleteAdvertence(advertence.id)}
                                    className="btn-outline-danger btn-small"
                                  >
                                    Excluir
                                  </Button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      </div>
                    ) : (
                      <p className="text-center">Divulgador não possui advertências neste evento.</p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </Container>
        )}
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/EventPromoters/index.js